/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Seed_NInputs */

const th_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`อันดับ ${i?.n}`)
};

const en_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seed ${i?.n}`)
};

const ja_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`シード${i?.n}`)
};

const zh_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`种子 ${i?.n}`)
};

const es_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cabeza de serie ${i?.n}`)
};

const pt_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cabeça de chave ${i?.n}`)
};

const id_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unggulan ${i?.n}`)
};

const fr_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tête de série ${i?.n}`)
};

const tl_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seed ${i?.n}`)
};

const vi_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Hạt giống ${i?.n}`)
};

const ko_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`시드 ${i?.n}`)
};

const de_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Gesetzt ${i?.n}`)
};

const ru_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Посев ${i?.n}`)
};

const tr_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.n}. seri başı`)
};

const it_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Testa di serie ${i?.n}`)
};

const pl_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rozstawienie ${i?.n}`)
};

const uk_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Посів ${i?.n}`)
};

const hi_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वरीयता ${i?.n}`)
};

const ar_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`المصنّف ${i?.n}`)
};

const ms_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pilihan ${i?.n}`)
};

const bn_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`বাছাই ${i?.n}`)
};

const zh_tw2_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`種子 ${i?.n}`)
};

const zh_hk2_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`種子 ${i?.n}`)
};

const ur_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`سیڈ ${i?.n}`)
};

const fa_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`سید ${i?.n}`)
};

const sw_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mbegu ${i?.n}`)
};

const nl_seed_n = /** @type {(inputs: Seed_NInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geplaatst ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Seed {n}" |
*
* @param {Seed_NInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const seed_n = /** @type {((inputs: Seed_NInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seed_NInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_seed_n(inputs)
	if (locale === "ja") return ja_seed_n(inputs)
	if (locale === "zh") return zh_seed_n(inputs)
	if (locale === "es") return es_seed_n(inputs)
	if (locale === "pt") return pt_seed_n(inputs)
	if (locale === "id") return id_seed_n(inputs)
	if (locale === "fr") return fr_seed_n(inputs)
	if (locale === "tl") return tl_seed_n(inputs)
	if (locale === "vi") return vi_seed_n(inputs)
	if (locale === "ko") return ko_seed_n(inputs)
	if (locale === "de") return de_seed_n(inputs)
	if (locale === "ru") return ru_seed_n(inputs)
	if (locale === "tr") return tr_seed_n(inputs)
	if (locale === "it") return it_seed_n(inputs)
	if (locale === "pl") return pl_seed_n(inputs)
	if (locale === "uk") return uk_seed_n(inputs)
	if (locale === "hi") return hi_seed_n(inputs)
	if (locale === "ar") return ar_seed_n(inputs)
	if (locale === "ms") return ms_seed_n(inputs)
	if (locale === "bn") return bn_seed_n(inputs)
	if (locale === "zh-TW") return zh_tw2_seed_n(inputs)
	if (locale === "zh-HK") return zh_hk2_seed_n(inputs)
	if (locale === "ur") return ur_seed_n(inputs)
	if (locale === "fa") return fa_seed_n(inputs)
	if (locale === "sw") return sw_seed_n(inputs)
	if (locale === "nl") return nl_seed_n(inputs)
	return en_seed_n(inputs)
});